import React, { useState } from "react";
import { ORG } from "../../data/costant";
import CaptchaLogin from "./CaptchaLogin";
import httpClient from "../../http/HttpRequest";
import { ENQUIRY } from "../../data/url";
import Alert from "../../utils/Alert";

const ContactDetails = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [captchaVerified, setCaptachaVerified] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      if (captchaVerified) {
        let payload = formData;
        const res = await httpClient.plainRequest(ENQUIRY, payload);
        if (res.requestStatus === "OK") {
          const result = res.result;
          if (result.status === 1) {
            Alert.success(result.message);
          } else {
            Alert.error(result.message);
          }
        }
      } else {
        Alert.error("Verify Captcha");
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }
    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    return newErrors;
  };

  const captchaResponse = (res) => {
    if (res.captchaVerify === "OK") {
      setCaptachaVerified(true);
    } else {
      setCaptachaVerified(false);
    }
  };

  return (
    <div className="container-fluid overflow-hidden py-2 px-lg-0">
      <div className="container contact-page  px-lg-0">
        <div className="row g-5 mx-lg-0">
          <div
            className="col-md-6 contact-form wow fadeIn"
            data-wow-delay="0.1s"
          >
            <h6 className="text-secondary text-uppercase">Get In Touch</h6>
            <h1 className="mb-4">Contact For Any Query</h1>
            <p className="mb-4">
              We value your feedback and inquiries! Whether you have questions,
              need assistance, or want to explore our logistics services, our
              team is always ready to help. Contact us today, and let’s build a
              seamless logistics solution together.
            </p>
            <div className="bg-light p-4">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Your Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      <label htmlFor="name">Your Name</label>
                    </div>
                    {errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Your Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <label htmlFor="email">Your Email</label>
                    </div>
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="mobile"
                        placeholder="Mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                      <label htmlFor="mobile">Mobile</label>
                    </div>
                    {errors.mobile && (
                      <small className="text-danger">{errors.mobile}</small>
                    )}
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Leave a message here"
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        style={{ height: "100px" }}
                      ></textarea>
                      <label htmlFor="message">Message</label>
                    </div>
                    {errors.message && (
                      <small className="text-danger">{errors.message}</small>
                    )}
                  </div>
                  <CaptchaLogin remitCaptcha={captchaResponse} />
                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100 py-3"
                      type="submit"
                    >
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div
            className="col-md-6 pe-lg-0 wow fadeInRight"
            data-wow-delay="0.1s"
          >
            <div className="position-relative h-100">
              <iframe
                className="position-absolute w-100 h-100"
                style={{ objectFit: "cover" }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30545.53517301647!2d79.54710938176886!3d16.86639924168963!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a352564f6cc4fd7%3A0x9e2e70f340fe2f33!2sMiryalaguda%2C%20Telangana%20508207!5e0!3m2!1sen!2sin!4v1733502681502!5m2!1sen!2sin"
                frameBorder="0"
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </div>
          </div>
        </div>
        <div className="row mx-lg-0 p-4">
          <div
            className="col-12 col-md-4 col-lg-4 wow fadeIn"
            data-wow-delay="0.1s"
          >
            <div
              className="bg-info p-4 mb-4 wow fadeIn"
              data-wow-delay="0.3s"
              style={{
                height: "160px",
                visibility: "visible",
                animationDelay: "0.3s",
                animationName: "fadeIn",
              }}
            >
              <i className="fa fa-home text-white mb-3"> Address :</i>
              <address className="text-white mb-0">{ORG.address}</address>
            </div>
          </div>
          <div
            className="col-12 col-md-4 col-lg-4 wow fadeIn"
            data-wow-delay="0.1s"
          >
            <div
              className="bg-dark p-4 mb-4 wow fadeIn"
              data-wow-delay="0.3s"
              style={{
                height: "160px",
                visibility: "visible",
                animationDelay: "0.3s",
                animationName: "fadeIn",
              }}
            >
              <i
                className="fa fa-link text-white mb-3"
                style={{ fontSize: "20px" }}
              >
                {" "}
                : {ORG.website}
              </i>{" "}
              <br />
              <i
                className="fa fa-phone text-white mb-3"
                style={{ fontSize: "20px" }}
              >
                {" "}
                : {ORG.mobile}
              </i>{" "}
              <br />
              <i
                className="fa fa-envelope text-white mb-3"
                style={{ fontSize: "20px" }}
              >
                {" "}
                : {ORG.email}
              </i>
            </div>
          </div>
          <div
            className="col-12 col-md-4 col-lg-4 wow fadeIn"
            data-wow-delay="0.1s"
          >
            <div
              className="bg-success p-4 mb-4 wow fadeIn"
              data-wow-delay="0.3s"
              style={{
                height: "160px",
                visibility: "visible",
                animationDelay: "0.3s",
                animationName: "fadeIn",
              }}
            >
              <span
                className="fa fa-whatsapp text-white mb-3"
                style={{ fontSize: "18px" }}
              >
                Open Hours : {ORG.hours}
              </span>{" "}
              <br />
              <span
                className="fa fa-whatsapp text-white mb-3"
                style={{ fontSize: "18px" }}
              >
                We are close on Saturday & Sunday
              </span>{" "}
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
